import styles from './LoadingDots.module.css';

export const LoadingDots = ({ small }) => {
  return (
    <div className="absolute top-0 left-0 flex z-50 items-center justify-center" style={{width: '100%', background: "#d1d6db", height: '100%'}}>
      <span className={styles.loader}></span>
    </div>
  );
};

export default LoadingDots;